import axios from "axios";
import { message, Modal } from "antd";
import * as app from "./app";
import { getServer } from "./options";
import { user } from "../redux/reducers";

let service = null;

function getService() {
  if (service) {
    return service;
  }

  const server = getServer();

  service = axios.create({
    baseURL: server.baseURL, // url = base url + request url
    timeout: server.timeout, // 请求超时
    // withCredentials: true, // send cookies when cross-domain requests
    ...(server.axios?.config || {})
  });

  // 请求拦截器
  service.interceptors.request.use(
    (config) => {
      const { tokenInfo } = user.state;
      const token = tokenInfo.token || config.token;
      if (token) {
        // 设置请求头令牌信息
        config.headers["Authorization"] = token;
      }
      return config;
    },
    (error) => {
      console.log(error);
      return Promise.reject(error);
    }
  );

  // 响应拦截器
  service.interceptors.response.use(
    (response) => {
      const res = response.data;
      if (200 === res.code) {
        return res;
      }

      if (response.config.handleError) {
        return Promise.reject(res);
      }

      message.error(res.message, 5);
      if (401 === res.code) {
        // 401: Illegal token 重新登录
        handleLogout();
      }
      return Promise.reject(res);
    },
    (error) => {
      console.log("err" + error);
      message.error(error.message || "ERROR", 5);
      return Promise.reject(error);
    }
  );

  function handleLogout() {
    if (!handleLogout.handle) {
      handleLogout.handle = true;
      Modal.warning({
        content: "已退出登录，请重新登录",
        okText: "确定",
        onOk() {
          app.logout().then(() => {
            window.location.reload();
          }).catch(() => {
            window.location.reload();
          });
        },
      });
    }
  }

  return service;
}

export function get(params) {
  const service = getService();
  return service({
    ...params,
    method: "get",
  });
}

export function post(params) {
  const service = getService();
  return service({
    ...params,
    method: "post",
  });
}
